var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRedshift = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#205B97",
    fillRule: "evenodd",
    d: "m20 28.467 12.18 2.897V8.571L20 11.47v16.998Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5193CE",
    d: "m32.18 8.571 2.32 1.16v20.474l-2.32 1.16zM20 28.467 7.82 31.364V8.571L20 11.47v16.998Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#205B97",
    fillRule: "evenodd",
    d: "M7.82 8.571 5.5 9.731v20.474l2.32 1.16z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5193CE",
    fillRule: "evenodd",
    d: "m23.094 36 4.64-2.318V6.318L23.094 4l-1.419 15.195z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#205B97",
    fillRule: "evenodd",
    d: "m16.906 36-4.64-2.318V6.318L16.906 4l1.419 15.195z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E73B7",
    fillRule: "evenodd",
    d: "M16.906 4h6.25v31.935h-6.25z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRedshift);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/redshift.238ec42b.svg";